import { render, staticRenderFns } from "./profile-details-form.vue?vue&type=template&id=45166a33"
import script from "./profile-details-form.vue?vue&type=script&lang=js"
export * from "./profile-details-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports